import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { initializeApp } from 'firebase/app';
import * as firebase from 'firebase/auth';
import { environment } from '@environment';
import { UtilService } from '../../../../shared/services';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss']
})
export class CaptchaComponent implements OnInit {

  @Input() type;
  @ViewChild('captcha', { static: true }) captcha;
  @Output() isCaptchaLoaded = new EventEmitter();
  public windowRef;
  challengePopup;

  constructor(
    private util: UtilService
  ) { }

  ngOnInit() {
    if (this.util.isBrowser) {
      this.initCaptcha();
    }
  }

  initCaptcha() {
    if (typeof window !== 'undefined') {
      this.windowRef = window;
      const app = initializeApp(environment.firebase);
      const auth = firebase.getAuth(app);
      this.windowRef.recaptchaVerifier = new firebase.RecaptchaVerifier(this.captcha.nativeElement, {
        'size': 'invisible'
      }, auth);
      this.windowRef.recaptchaVerifier.render().then(widgetId => {
        this.windowRef.recaptchaWidgetId = widgetId;
        this.isCaptchaLoaded.next(true);
        this.checkForChallengePopup();
      });
    }
  }

  /**Check for challenge popup and
   * set the position of the popup in order to
   * view correctly when its open in dialod/modal
   */
  checkForChallengePopup() {
    if (this.type === 'dialog' && typeof document !== 'undefined') {
      const html: HTMLElement = document.getElementsByTagName('html')[0];
      this.challengePopup = document.querySelector(`[title='recaptcha challenge']`);
      this.challengePopup ? html.style.top = '0px' : setTimeout(() => this.checkForChallengePopup(), 2000);
    }
  }

}
